// extracted by mini-css-extract-plugin
module.exports = {"footer":"DashFooter_footer__2VkkC","footer__col1":"DashFooter_footer__col1__hE-s4"};